import request from "@/utils/request";

// 查询用户列表
export function getUserList(params) {
  return request({
    url: "/admin/users",
    method: "get",
    params: params
  });
}

// 获取列表用户详情
export function getUser(userId) {
  return request({
    url: "/admin/users/getInfo?userId="+userId,
    method: "get"
  });
}

// 查询在线用户列表
export function listOnlineUser(params) {
  return request({
    url: "/admin/users/online",
    method: "get",
    params: params
  });
}
//修改禁用状态
export function updateUserDisable(data) {
  return request({
    url: "/admin/users/disable",
    method: "put",
    data: data
  });
}

// 查询用户角色选项
export function getUsersRoleList() {
  return request({
    url: "/admin/users/role",
    method: "get"
  });
}

//修改用户昵称及角色
export function updateUserRole(data) {
  return request({
    url: "/admin/users/role",
    method: "put",
    data: data
  });
}

// 查询用户菜单列表
export function getUserMenusList(params) {
  return request({
    url: "/admin/users/menus",
    method: "get",
    params: params
  });
}

// 在线用户下限
export function removeOnlineUser(token) {
  return request({
    url: "/admin/users/online/" + token,
    method: "delete"
  });
}

// 获取个人中心用户信息
export function getUserProfile() {
  return request({
    url: "/admin/profile",
    method: "get"
  });
}


//修改个人信息
export function updateUserProfile(data) {
  return request({
    url: "/admin/profile",
    method: "put",
    data: data
  });
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/admin/profile/avatar',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data
  })
}

//修改密码
export function updateUserPassword(data) {
  return request({
    url: "/admin/profile/password",
    method: "put",
    data: data
  });
}
